var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isPopulatedArray } from './array';
/**
 * Nests an array of Nodes assuming they have a parent meta data (parent value)
 *
 * @param id when invoking it, set it to the root Node value
 */
export var nest = function (items, id) {
    return items
        .filter(function (item) { var _a; return ((_a = item.meta) === null || _a === void 0 ? void 0 : _a.parent) === id; })
        .map(function (item) { return (__assign(__assign({}, item), { children: nest(items, item.value) })); });
};
export var flattenNodes = function (nodes) {
    var children = [];
    var flattenMembers = nodes.map(function (m) {
        if (m.children && m.children.length) {
            children = __spreadArray(__spreadArray([], children, true), m.children, true);
        }
        return m;
    });
    return flattenMembers.concat(children.length ? flattenNodes(children) : children);
};
export var getLeafNodes = function (nodes) {
    var leafs = [];
    var getLeafs = function (nodes) {
        var children = [];
        nodes.forEach(function (n) {
            if (!isPopulatedArray(n.children)) {
                leafs.push(n);
            }
            else {
                children.push.apply(children, n.children);
            }
        });
        if (children.length > 0) {
            return getLeafs(children);
        }
        return undefined;
    };
    getLeafs(nodes);
    return leafs;
};
//# sourceMappingURL=tree.js.map